import "./App.css";
import Background from "./components/BackGround/Background";
import QRGenerator from "./components/QRGenerator/QRGenerator";

function App() {
  return (
    <>
      <Background />
      <QRGenerator />
    </>
  );
}

export default App;
